import React,{useContext} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';


import Login from './pages/Login';
import Usuarios from './pages/Usuarios';
import Produtos from './pages/Produtos';
import Fornecedores from './pages/Fornecedores';

import useAuth from './Context/hooks/useAuth';
import Header from './components/Header';

import Menu from './components/navegacao/Menu';
import {SistemaContainer} from './components/Utils';

const CustomRoute = ({isPrivate, ...rest}) => {

    const {authenticated, loading} = useAuth();

    if(loading){
        return (
            <div style={{  display: "flex", alignItems: "center", verticalAlign: "middle", height: "100vh", justifyContent: "center"}}>
                <CircularProgress />
            </div>
        )
    }

    if(isPrivate && !authenticated){
        return <Redirect to="/login" />
    }

    return <Route {...rest} />

}

const Routes = props => {

    const {authenticated, loading, user} = useAuth();

    if(authenticated){
        return(
            <SistemaContainer>
                <Menu />
                <Header />
                <Switch>
                        <CustomRoute isPrivate path="/usuarios" component = {Usuarios} />
                        <CustomRoute isPrivate path="/produtos" component = {Produtos} />
                        <CustomRoute isPrivate path="/fornecedores" component = {Fornecedores} />
                </Switch>
            </SistemaContainer>
        )
    }
    return(
        <Switch>
             <CustomRoute path="" component = {Login} />
            <CustomRoute path="/login" component = {Login} />
        </Switch>
    )
}

export default Routes;
